export { default as Header } from './Header'
export { default as HeroBanner } from './HeroBanner/HeroBanner'
export { default as LogosCarousel } from './LogosCarousel/LogosCarousel'
export { default as SectionAppBioAtlas } from './SectionAppBioAtlas/SectionAppBioAtlas'
export { default as SectionCtaBioAtlas } from './SectionCtaBioAtlas/SectionCtaBioAtlas'
export { default as SectionCtaCytology } from './SectionCtaCytology/SectionCtaCytology'
export { default as SectionDepoimentos } from './SectionDepoimentos/SectionDepoimentos'
export { default as SectionEnriquecaAulas } from './SectionEnriquecaAulas/SectionEnriquecaAulas'
export { default as SectionEstudanteProfissional } from './SectionEstudanteProfissional/SectionEstudanteProfissional'
export { default as SectionModulosBioAtlas } from './SectionModulosBioAtlas/SectionModulosBioAtlas'
export { default as SectionResultsAndEstudante } from './SectionResultsAndEstudante/SectionResultsAndEstudante'
export { default as SectionSolucaoBioAtlas } from './SectionSolucaoBioAtlas/SectionSolucaoBioAtlas'
export { default as SectionVantagensInstituicao } from './SectionVantagensInstituicao/SectionVantagensInstituicao'
export { default as SectionResults } from './SectionResults/SectionResults'
